export default __webpack_public_path__ + "static/media/STRIPAnimatGif-ForceBlack.c00d33ac.gif";